import { render, staticRenderFns } from "./Anesthesiologist.vue?vue&type=template&id=0c892332&scoped=true"
import script from "./Anesthesiologist.vue?vue&type=script&lang=js"
export * from "./Anesthesiologist.vue?vue&type=script&lang=js"
import style0 from "./Anesthesiologist.vue?vue&type=style&index=0&id=0c892332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c892332",
  null
  
)

export default component.exports